import React, { useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
} from '@mui/material';
import CouponItem from './CouponItem';
import EditCouponDialog from '../dialogs/EditCouponDialog';
import { Schema } from '../../../../../amplify/data/resource';
import theme from '../../../../theme';
import ReactLoading from 'react-loading';

// @ts-ignore
type Coupon = Schema['Coupon']['type'];

interface CouponTableProps {
  coupons: Coupon[];
  loading: boolean;
  onCouponUpdated: () => void;
}

const CouponTable: React.FC<CouponTableProps> = ({ coupons, loading, onCouponUpdated }) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState<Coupon | null>(null);

  const sortedCoupons = [...coupons].sort((a, b) => {
    return (a.code || '').localeCompare(b.code || '');
  });

  const handleEditClick = (coupon: Coupon) => {
    setSelectedCoupon(coupon);
    setEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditDialogOpen(false);
    setSelectedCoupon(null);
  };

  const handleEditSubmit = () => {
    onCouponUpdated();
    handleEditClose();
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <ReactLoading
            type={'bubbles'}
            color={theme.palette.green.main}
            height={250}
            width={250}
          />
      </Box>
    );
  }

  return (
    <Box sx={{ direction: 'rtl' }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflowY: 'auto',
        }}
      >
        <Table
          stickyHeader
          sx={{
            backgroundColor: 'transparent',
            borderCollapse: 'separate',
            borderSpacing: '0 10px',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: '#E7ECF1' }}>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  קוד קופון
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תיאור
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סוג הנחה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  ערך הנחה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תאריך התחלה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תאריך סיום
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  מגבלת שימוש
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סטטוס
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  borderTopLeftRadius: '10px',
                  borderBottomLeftRadius: '10px',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  פעולות
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedCoupons.map((coupon) => (
              <CouponItem 
                key={coupon.id} 
                coupon={coupon} 
                onEditClick={handleEditClick}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {sortedCoupons.length === 0 && !loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={4}
          textAlign="center"
        >
          <Typography
            color="textSecondary"
            fontFamily="AlmoniDL"
            fontSize="16px"
          >
            אין קופונים להציג
          </Typography>
        </Box>
      )}

      <EditCouponDialog
        open={editDialogOpen}
        onClose={handleEditClose}
        onSubmit={handleEditSubmit}
        coupon={selectedCoupon}
      />
    </Box>
  );
};

export default CouponTable; 